import React, {Component} from 'react';
import NavBarKS from "../../components/NavBarKS";
import {
    changeNumberFormat,
    getReferenceIdList,
    getYearsList,
    hasUserRight,
    isGursut,
    showAxiosError
} from "../../helper/helper";
import {UserRightsEnum} from "../../helper/enums";
import StickButton from "../../components/StickButton";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import {showConnector, showConnectorPayment} from "../../helper/permission";
import {EntegratorConf} from "../../constants";
import Table from "../../components/Table/Table";
import axios from "axios";
import {request} from "../../helper/APIUtils";
import TextOverFlowTooltip from "../../components/TextOverFlowTooltip";
import moment from "moment/moment";
import MediaViewer from "../einvoice/MediaViewer";
import SweetAlert from "react-bootstrap-sweetalert";
import Alert from "react-s-alert";
import DefaultModal from "../invoice/DefaultModal";
import Select from "../../local_node_modules/react-select";
import SendMultipleModal from "../voucher/component/SendMultipleModal";
import ReadFromExcel from "../voucher/component/ReadFromExcel";
import CustomaryPriceModal from "../connector/CustomaryPriceModal";
import ConnectorPaymentModal from "../connector/ConnectorPaymentModal";
import ConnectorModal from "../connector/ConnectorModal";

class SigortaTmpList extends Component {
    constructor(props) {
        super(props);
        const yearsList = getYearsList();
        this.state = {
            years: yearsList,
            year: yearsList[0],
            month: new Date().getMonth(),
            mediaModal: false,
            manual: false,
            content: [],
            total: 0,
            loading: false,
            searching: false,
            searchQuery: undefined,
            page: 0,
            size: 10,
            selection: [],
            selectedAll: false,
            windowSize: window.matchMedia('(max-width: 1024px)'),
            sendBtnDisabled: false,
            deleteBtnDisabled: false,
            item: null,
            index: -1,
            isLoadingSigortaDeleteAll: false,
            isLoadingSigortaDeleteSelected: false,
            showExcelModal: false,
            customaryPriceModal: false,
            showConnectorModal: false
        }
        this.handleCreate = this.handleCreate.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.getTrStyles = this.getTrStyles.bind(this);
        this.downloadMedia = this.downloadMedia.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.toggleCheckboxChange = this.toggleCheckboxChange.bind(this);
        this.isSelected = this.isSelected.bind(this);
        this.setMediaViewer = this.setMediaViewer.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.cancelDelete = this.cancelDelete.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.confirmSend = this.confirmSend.bind(this);
        this.handleSend = this.handleSend.bind(this);
        this.deleteSigorta = this.deleteSigorta.bind(this);
        this.sendMultiple = this.sendMultiple.bind(this);
        this.checkCustomaryPrice = this.checkCustomaryPrice.bind(this);
        this.checkConnectorPayment = this.checkConnectorPayment.bind(this);
        this.copyEditSigorta = this.copyEditSigorta.bind(this);
    }

    handleCreate() {
        this.props.history.push(`/createEditSigorta/0`)
    }

    handleEdit(item) {
        this.props.history.push(`/createEditSigorta/${item.recordId}`);
    }

    copyEditSigorta(item, type) {
        let self = this;
        let params = {
            url: `/sigorta/copyEditSigorta`,
            method: 'post',
            data: {
                documentUuid: item.documentUuid,
                type: type
            }
        };

        Alert.info("sigorta " + (type === "edit" ? "düzenleme" : "kopyalama") + " için kontrol ediliyor..", {
            position: 'top-right',
            effect: 'stackslide',
            timeout: 'none'
        });

        request(params)
            .then((response) => {
                let sigorta = response.data;
                Alert.closeAll();
                Alert.success("Sigorta " + (type === "edit" ? "düzenleme" : "kopyalama") + " için hazırlandı.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                });
                self.props.history.push(`/createEditSigorta/${sigorta.recordId}`);
            }).catch(function (error) {
            Alert.closeAll();
            showAxiosError(error);
        });
    }

    getTrStyles(row) {
        return {backgroundColor: (this.isSelected(row.recordId) ? "#ffc" : "inherit")};
    }

    fetchData(accessor, direction, page, size) {
        let self = this;

        if (typeof this._fetchToken !== typeof undefined) {
            this._fetchToken.cancel();
        }

        this._fetchToken = axios.CancelToken.source();

        let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '&sort=recordId,desc';
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
        let params = {
            url: '/sigorta/getAllSigorta?page=' + page + '&size=' + size + searchQuery + sortStr,
            method: "post",
            cancelToken: this._fetchToken.token
        };

        self.setState({
            loading: true,
            searching: false,
            manual: self.manual === true ? false : self.manual,
        });
        self.props.reload(true);
        request(params)
            .then(function (response) {
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    content: response.data.content,
                    loading: false,
                    searching: false,
                    selectedAll: false,
                    selection: [],
                });
                self.props.reload(false);
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            self.props.reload(false);
            showAxiosError(error);
        });
    }

    downloadMedia(item, type, index) {
        let self = this;
        let params = {
            url: `/sigorta/downloadTmpMedia`,
            responseType: 'arraybuffer',
            method: "post",
            data: {
                documentUuid: item.documentUuid,
                mediaType: type
            }
        };
        if (type !== "xml")
            self.setState({mediaModal: true, title: item.documentUuid, selectedItem: item, selectedIndex: index});

        request(params)
            .then(function (response) {
                let blob = new Blob([response.data], {type: response.headers["content-type"]});
                let urlCreator = window.URL || window.webkitURL;
                let url = urlCreator.createObjectURL(blob);
                if (type !== "xml") {
                    self.setState({url: url});
                } else {
                    let a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    a.download = item.documentUuid + ".xml";
                    a.click();
                }
            }).catch(function (error) {
            if (error.response === undefined) {
                showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
            } else {
                let enc = new TextDecoder("utf-8");
                showAxiosError({message: enc.decode(error.response.data)});
            }
            self.setState({mediaModal: false, title: null});
        });
    }

    handleDelete(item, index) {
        this.setState({showSwal: true, item: item, index: index, mediaModal: false});
    }

    toggleCheckboxChange(e, row, id) {
        let self = this;
        let checked = e.target.checked;
        let items = self.state.content;
        let selection = self.state.selection;
        if (row === "all") {
            let selection = [];
            if (checked) {
                items.forEach(item => {
                    selection.push(item[id]);
                });
            }
            self.setState({selection: selection, selectedAll: checked});
        } else {
            let index = selection.indexOf(row[id]);
            if (index >= 0) {
                selection = [
                    ...selection.slice(0, index),
                    ...selection.slice(index + 1)
                ];
            } else {
                selection.push(row[id]);
            }
            self.setState({
                selection: selection,
                selectedAll: ((selection.length > 0) ? (selection.length === self.state.content.length) : false)
            });
        }
    }

    isSelected(id) {
        return (this.state.selection.indexOf(id) !== -1);
    }

    setMediaViewer() {
        this.setState({url: null, mediaModal: false});
    }

    handleSearch(searchQuery) {
        this.setState({
            searchQuery,
            searching: true
        }, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size))
    }

    cancelDelete() {
        this.setState({showSwal: false, item: null});
    }

    confirmDelete() {
        let self = this;
        let item = self.state.item;
        let params = {
            url: `/sigorta/delete/${item.recordId}`,
            method: 'post'
        };
        self.setState({deleteBtnDisabled: true});
        request(params)
            .then(function (response) {
                self.setState({loading: false, showSwal: false, deleteBtnDisabled: false, manual: true});
                Alert.success("Silme işlemi başarıyla gerçekleştirildi.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                });
            }).catch(function (error) {
            self.setState({loading: false, showSwal: false, deleteBtnDisabled: false});
            showAxiosError(error);
        });
    }

    handleSend(item) {
        let self = this;
        let params = {
            url: `/sigorta/getPrefixCode/${item.recordId}`,
            method: 'post'
        };

        self.setState({reactLoading: true});
        request(params)
            .then(self.setState({mediaModal: false}))
            .then(function (response) {
                let prefixCodes = response.data;
                self.setState({
                    showSendSwal: true,
                    prefixCodes: prefixCodes,
                    documentId: prefixCodes[0].value,
                    lastIssueDate: prefixCodes[0].lastIssueDate,
                    item: item,
                });
            }).catch(function (error) {
            showAxiosError(error);
        }).then(function () {
            self.setState({reactLoading: false});
        });
    }

    confirmSend() {
        let self = this;
        let item = self.state.item;
        let params = {
            url: `/sigorta/send`,
            method: 'post',
            data: {
                recordId: item.recordId,
                documentId: this.state.documentId,
                lastIssueDate: this.state.lastIssueDate
            }
        };


        self.setState({sendBtnDisabled: true});
        request(params)
            .then(function (response) {
                if(item.from === "CONNECTOR"){
                    self.updateSigortaNumberWs(item.recordId);
                }
                self.setState({showSendSwal: false, sendBtnDisabled: false, manual: true});
                Alert.success("Gönderim başarılı şekilde gerçekleştirildi.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            }).catch(function (error) {
            self.setState({sendBtnDisabled: false, showSendSwal: false});
            showAxiosError(error);
        });
    }

    sendMultiple(data) {
        let {showSendModal, sendType} = data;
        if ((sendType === "all" && this.state.total > 0) || (this.state.selection && this.state.selection.length > 0)) {
            this.setState({showSendModal, sendType})
        } else {
            Alert.error(((sendType === "all") ? "Toplu gönderilecek sigorta bulunamadı" : "Seçili sigorta bulunamadı."), {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000
            });
        }
    }

    deleteSigorta(deleteType) {
        let self = this;
        let chosen = this.state.selection;
        let type = self.props.type;

        if (deleteType === "all") {
            this.setState({isLoadingSigortaDeleteAll: true});
        } else {
            this.setState({isLoadingSigortaDeleteSelected: true});
        }

        if ((deleteType === "all" && this.state.total > 0) || (this.state.selection && this.state.selection.length > 0)) {
            let params = {
                url: `/sigorta/deleteSigorta`,
                method: 'post',
                data: {
                    type,
                    deleteType,
                    recordIdList: chosen
                }
            };

            request(params)
                .then(function (response) {
                    self.setState({
                        showSendSwal: false,
                        showDeleteSwal: false,
                        manual: true,
                        isLoadingSigortaDeleteAll: false,
                        isLoadingSigortaDeleteSelected: false
                    });
                    Alert.success("Silme işlemi başarıyla gerçekleştirildi.", {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                })
                .catch(function (error) {
                    self.setState({
                        isLoadingSigortaDeleteAll: false,
                        isLoadingSigortaDeleteSelected: false
                    });
                    showAxiosError(error);
                });

        } else {
            this.setState({
                isLoadingSigortaDeleteAll: false,
                isLoadingSigortaDeleteSelected: false
            });
            Alert.error(((deleteType === "all") ? "Toplu silinecek sigorta bulunamadı" : "Seçili silinecek bulunamadı."), {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000
            });
        }
    }

    async checkCustomaryPrice() {
        let self = this;
        let result = await self.checkConnectorPayment();
        const propType = result.checkPropType ? result.checkPropType : [];

        if ((propType.length !== 0 || result.checkUpdated === true || result.checkInstallation === true) && showConnectorPayment(EntegratorConf.identifier) && this.props.currentUser.parentCustomerWorkType === 2 && this.props.currentUser.isParentCustomerDistributor) {
            Alert.error('Bayiniz ile ödeme için görüşünüz.', {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000,
                html: false
            });
        } else if ((propType.length !== 0 || result.checkUpdated === true || result.checkInstallation === true) && showConnectorPayment(EntegratorConf.identifier)) {
            this.setState({connectorPaymentModal: true});
        } else {
            if (showConnectorPayment(EntegratorConf.identifier)) {
                let params = {
                    url: `/connector/fetchErpPaymentInformation`,
                    method: "get"
                };
                request(params)
                    .then(function (response) {
                        console.log(response)
                        let data = response.data;
                        if (showConnectorPayment(EntegratorConf.identifier))
                            if ((propType.length !== 0 || result.checkUpdated === true || result.checkInstallation === true) && showConnectorPayment(EntegratorConf.identifier)) {
                                self.setState({customaryPriceModal: true});
                            } else {
                                self.setState({showConnectorModal: true});
                            }
                    }).catch(function (error) {
                    showAxiosError(error);
                });
            } else {
                self.setState({showConnectorModal: true});
            }
        }
    }

    checkConnectorPayment(){
        return new Promise((resolve) => {
            let propType = "sigorta";
            let params = {
                url: `/connector/checkConnectorPayment?propType=${propType}`,
                method: "get"
            };
            request(params).then((response) => {
                let result = response.data;
                resolve(result);
            })
        });
    }

    render() {
        const isCreditSufficient = this.state.isCreditSufficient != undefined ? this.state.isCreditSufficient : true;
        const columns = [
            {
                Header: (<input type="checkbox" checked={this.state.selectedAll}
                                onChange={(e) => this.toggleCheckboxChange(e, "all", "recordId")}/>),
                accessor: "recordId",
                selectType: "checkbox",
                sortable: false,
                Cell: (row, index) => (<input type="checkbox" checked={this.isSelected(row.recordId)}
                                              onChange={(e) => this.toggleCheckboxChange(e, row, "recordId", index)}/>)
            },
            {
                accessor: this.props.direction !== "Tmp" ? [
                    {Header: "Sigorta No", accessor: "documentId"},
                    {Header: "ETTN", accessor: "documentUuid"}
                ] : [
                    {Header: "ETTN", accessor: "documentUuid"}
                ],
                Cell: row => (row.documentId !== null ? (
                        <div>{row.documentId}<br/> <TextOverFlowTooltip text={row.documentUuid} maxLength={20}/>
                        </div>) :
                    <TextOverFlowTooltip text={row.documentUuid} maxLength={20}/>)
            },
            {
                accessor: [
                    {Header: "VKN/TCKN", accessor: "vknTckn", sortable: true},
                    {Header: "Unvan", accessor: "title", sortable: false}
                ],
                Cell: row => (row && row.vknTckn ?
                    (<div>{row.vknTckn}<br/><TextOverFlowTooltip text={row.title} maxLength={20}/></div>) : "")
            },
            {
                accessor: [
                    {Header: "Belge Numarası", accessor: "documentNumber"},
                    {Header: "Oluşturulma Yeri", accessor: "referenceId"}
                ],
                Cell: row => (
                    <div>{row.documentNumber ? row.documentNumber:''}<br/>
                        {row.referenceId ? <p className="text-info" style={{margin: 0}}>ERP</p> : <p className="text-success" style={{margin: 0}}>PORTAL</p>}
                    </div>)
            },
            {
                Header: "Sigorta Tarihi",
                accessor: "issueDate",
                Cell: row => (
                    <div>{moment(row.issueDate).isValid() ? moment(row.issueDate).format("DD-MM-YYYY") : ''}</div>)
            },
            {
                accessor: [
                    {Header: "Belge Türü", accessor: "profileId"},
                    {Header: "Sigorta Türü", accessor: "documentTypeCode"}
                ],
                Cell: row => (<div> {row.profileId} <br/> {row.documentTypeCode} </div>)
            },
            {
                Header: "İptal Komisyonu Tutarı",
                accessor: "chargeTotalAmount",
                Cell: row => (
                    <div>{(changeNumberFormat(row.chargeTotalAmount))} {(row.documentCurrencyCode || "")}</div>)
            },
            {
                Header: "İstihsal Komisyonu Tutarı",
                accessor: "allowanceTotalAmount",
                Cell: row => (
                    <div>{(changeNumberFormat(row.allowanceTotalAmount))} {(row.documentCurrencyCode || "")}</div>)
            },
            {
                Header: "İşlemler",
                accessor: "",
                width: "11%",
                sortable: false,
                Cell: (item, index) => (
                    <div className="btn-group">
                        <div className="dropdown">
                            <button className="MenuBtn2 listt btn btn-default" type="button"
                                    disabled={!isCreditSufficient}
                                    data-toggle="dropdown">Seçİnİz
                            </button>
                            <div className="dropdown-menu" aria-labelledby={"dropdownMenuButton_" + item.recordId}>

                                {hasUserRight((UserRightsEnum.sigorta.send), this.props.currentUser) &&
                                    <a className="dropdown-item" onClick={() => {
                                        this.setState({documentId: item.documentId, item: item});
                                        this.handleSend(item, index);
                                    }}>
                                        <i className="fa fa-send"/> Sigortayı Gönder
                                    </a>
                                }

                                {hasUserRight(UserRightsEnum.sigorta.update, this.props.currentUser) &&
                                    <a className="dropdown-item" onClick={() => this.handleEdit(item)}>
                                        <i className="fa fa-edit"/> Sigorta Düzenle
                                    </a>
                                }
                                {hasUserRight(UserRightsEnum.sigorta.view, this.props.currentUser) &&
                                    <a className="dropdown-item"
                                       onClick={() => this.downloadMedia(item, this.state.windowSize.matches ? "html" : "pdf", index)}>
                                        <i className="fa fa-eye"/> Sigorta Göster
                                    </a>
                                }
                                {hasUserRight(UserRightsEnum.sigorta.view, this.props.currentUser) &&
                                    <a className="dropdown-item" onClick={() => this.downloadMedia(item, "xml")}>
                                        <i className="fa fa-download"/> Sigorta XML İndir
                                    </a>
                                }

                                {hasUserRight(UserRightsEnum.sigorta.delete, this.props.currentUser) &&
                                    <a className="dropdown-item" onClick={() => this.handleDelete(item)}>
                                        <i className="fa fa-trash-alt"/> Sigortayı Sil
                                    </a>
                                }
                            </div>
                        </div>
                    </div>
                )
            }
        ];

        const fields = [
            {
                label: "Sigorta Numarası",
                accessor: "documentId",
                type: "text",
                operator: "=",
            },
            {
                label: "Alıcı Unvan",
                accessor: "title",
                type: "text",
                operator: "=",
            },
            {
                label: "Alıcı VKN/TCKN",
                accessor: "vknTckn",
                type: "numericText",
                operator: "=",
            },
            {
                label: "Sigorta Tarihi (Başlangıç)",
                accessor: "min_issueDate",
                type: "datetime",
                operator: ">=",
            },
            {
                label: "Sigorta Tarihi (Bitiş)",
                accessor: "max_issueDate",
                type: "datetime",
                operator: "<=",
            },
            {
                label: "Oluşturulma Yeri",
                accessor: "referenceId",
                type: "select",
                operator: "=",
                selectData: getReferenceIdList((showConnector(EntegratorConf.identifier) && hasUserRight(UserRightsEnum.ekonnektor.view, this.props.currentUser)))
            },
            {
                label: "Belge No",
                accessor: "documentNumber",
                type: "text",
                operator: "=",
            }
        ];
        return (
            <div className="row baseBackground">
                <NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth} name='sigortaTmp'>
                    <StickButton position="leftSide"
                                 onClick={() => this.handleCreate()}
                                 label="Yeni Oluştur"
                                 title="Yeni Oluştur"
                                 disabled={(!hasUserRight(UserRightsEnum.sigorta.create, this.props.currentUser))}
                                 className="stickButton plus-circle"
                                 icon="plus-circle"/>

                    <StickButton position="leftSide"
                                 title="Excel'den Taslağa Kaydet"
                                 label="Excel'den Taslağa Kaydet"
                                 className="stickButton excel"
                                 icon="excel"
                                 disabled={!isCreditSufficient || (!hasUserRight(UserRightsEnum.sigorta.send, this.props.currentUser))}
                                 onClick={(e) => this.setState({showExcelModal: true})}/>

                    <StickButton
                        position="leftSide"
                        title="Seçilileri Gönder"
                        label="Seçilileri Gönder"
                        className={isGursut(this.props.currentUser.vknTckn) ? "stickButtonGreen send" : "stickButton send"}
                        icon='send'
                        disabled={!isCreditSufficient || this.state.selection.length === 0 || (!hasUserRight(UserRightsEnum.sigorta.send, this.props.currentUser))}
                        onClick={(e) => this.sendMultiple({showSendModal: true, sendType: "selected"})}
                    />

                    <StickButton
                        position="leftSide"
                        title="Tümünü Gönder"
                        label="Tümünü Gönder"
                        className={isGursut(this.props.currentUser.vknTckn) ? "stickButtonGreen send" : "stickButton send"}
                        icon='send'
                        disabled={!isCreditSufficient || (!hasUserRight(UserRightsEnum.sigorta.send, this.props.currentUser))}
                        onClick={(e) => this.sendMultiple({showSendModal: true, sendType: "all"})}
                    />

                    <StickButton
                        position="leftSide"
                        title="Seçilileri Sil"
                        label={this.state.isLoadingSigortaDeleteSelected ? "Siliniyor..." : "Seçilileri Sil"}
                        className={isGursut(this.props.currentUser.vknTckn) ? "stickButtonRed trash" : "stickButton trash"}
                        disabled={this.state.isLoadingSigortaDeleteSelected || !isCreditSufficient || this.state.selection.length === 0 || (!hasUserRight(UserRightsEnum.sigorta.send, this.props.currentUser))}
                        onClick={() => {
                            this.setState({
                                isLoadingSigortaDeleteSelected: true,
                                buttonStyle: "fas fa-spinner fa-spin"
                            });
                            this.deleteSigorta("selected");
                        }}
                    >
                        {this.state.isLoadingSigortaDeleteSelected && <i className={this.state.buttonStyle}/>}
                    </StickButton>


                    <StickButton
                        position="leftSide"
                        title="Tümünü Sil"
                        label={this.state.isLoadingSigortaDeleteAll ? "Siliniyor..." : "Tümünü Sil"}
                        className={isGursut(this.props.currentUser.vknTckn) ? "stickButtonRed trash" : "stickButton trash"}
                        disabled={this.state.isLoadingSigortaDeleteAll || !isCreditSufficient || (!hasUserRight(UserRightsEnum.sigorta.send, this.props.currentUser))}
                        onClick={() => {
                            this.setState({isLoadingSigortaDeleteAll: true});
                            this.deleteSigorta("all", () => {
                                this.setState({isLoadingSigortaDeleteAll: false});
                            });
                        }}
                    >{this.state.isLoadingSigortaDeleteAll && <i className="fas fa-spinner fa-spin"/>}
                    </StickButton>

                    {(showConnector(EntegratorConf.identifier) && hasUserRight(UserRightsEnum.ekonnektor.view, this.props.currentUser)) &&
                        <StickButton position="leftSide"
                                     title="ERP'den Getir"
                                     label="ERP'den Getir"
                                     type="invoice"
                                     className="stickButton arrow-down"
                                     onClick={this.checkCustomaryPrice}
                                     disabled={!isCreditSufficient || (!(hasUserRight(UserRightsEnum.ekonnektor.view, this.props.currentUser)))}
                                     icon="arrow-down"/>
                    }

                </NavBarKS>

                <div className="col-sm-12 satirBasi">
                    <div className="card-header">
                        <h4 className="card-title">Taslak Sigorta</h4>
                    </div>
                    <div className="card-body" style={{paddingBottom: '0px'}}>
                        <div style={{marginTop: '10px', marginBottom: '0px'}}>
                            <DetailedSearch fields={fields}
                                            loading={this.state.searching}
                                            onSearch={this.handleSearch}/>
                        </div>
                    </div>

                    <div className="col-sm-12">
                        <Table columns={columns}
                               loading={this.state.loading}
                               loadingText="Kayıtlar getiriliyor..."
                               content={this.state.content}
                               total={this.state.total}
                               page={this.state.page}
                               manual={this.state.manual}
                               size={this.state.size}
                               options={["5", "10", "20", "50", "100"]}
                               fetchData={this.fetchData}
                               getTrStyles={this.getTrStyles}
                               jumberEnabled={true}
                               topPagination={this.state.size >= 20 && this.state.total >= 20}
                        />
                    </div>
                </div>
                {this.state.mediaModal &&
                    <MediaViewer modal={this.state.mediaModal}
                                 url={this.state.url}
                                 title={this.state.title}
                                 listener={this.setMediaViewer}
                                 selectedItem={this.state.selectedItem}
                                 selectedIndex={this.state.selectedIndex}
                                 currentUser={this.props.currentUser}
                                 location='TmpSigorta'
                                 handleEdit={this.handleEdit}
                                 handleSend={this.handleSend}
                                 downloadMedia={this.downloadMedia}
                                 copyEditSigorta={this.copyEditSigorta}
                                 handleDelete={this.handleDelete}
                    />
                }

                {this.state.showSwal &&
                    <SweetAlert
                        showCancel
                        closeOnClickOutside={false}
                        hideOverlay={false}
                        disabled={this.state.deleteBtnDisabled}
                        confirmBtnText="Evet"
                        confirmBtnCssClass="TekBtn gonder "
                        confirmBtnStyle={{float: 'right'}}
                        cancelBtnText="Hayır"
                        cancelBtnCssClass="TekBtn vazgec "
                        cancelBtnStyle={{
                            background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
                            float: 'left'
                        }}
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="default"
                        title="Silme Onayı"
                        style={{width: 400}}
                        onConfirm={this.confirmDelete}
                        onCancel={this.cancelDelete}
                    >
                        Sigortanın silinmesini onaylıyor musunuz?
                    </SweetAlert>
                }

                {this.state.showSendSwal &&
                    <DefaultModal
                        disabled={this.state.sendBtnDisabled}
                        isOpen={this.state.showSendSwal}
                        title={"Kullanmak İstediğiniz Öneki Seçiniz"}
                        confirmBtnText="Gönder"
                        cancelBtnText="İptal"
                        onConfirm={this.confirmSend}
                        onCancel={(e) => this.setState({showSendSwal: false})}
                    >
                        <div className="col-sm-12">
                            <h5 style={{
                                fontFamily: 'Century Gothic',
                                fontSize: '1em',
                                fontWeight: 100,
                                textAlign: "center"
                            }}
                                className="text-danger">{this.state.documentId}</h5>
                        </div>
                        <div className="col-sm-12">
                            <Select
                                value={this.state.documentId}
                                clearable={false}
                                placeholder="Seçiniz..."
                                noResultsText="Kayıt bulunamadı."
                                onChange={(e) => this.setState({
                                    documentId: e.value,
                                    lastIssueDate: e.lastIssueDate
                                })}
                                options={this.state.prefixCodes.map(prefixCode => ({
                                    value: prefixCode.value,
                                    label: prefixCode.label,
                                    lastIssueDate: prefixCode.lastIssueDate
                                }))}
                            />
                        </div>
                    </DefaultModal>
                }

                {this.state.showSendModal &&
                    <SendMultipleModal
                        type={"sigorta"}
                        profileId={("ESIGORTA")}
                        recordIds={this.state.selection}
                        sendType={this.state.sendType}
                        title={this.state.sendType === "all" ? "Sigortaların Tümünü Gönderme İşlemi" : "Seçili Sigortaları Gönderme İşlemi"}
                        toggleModal={(flag, manual) => this.setState({showSendModal: flag, manual: manual})}
                        modal={this.state.showSendModal}/>
                }

                {this.state.showExcelModal &&
                    <ReadFromExcel
                        type="sigorta"
                        profileId={this.props.profileId}
                        toggleModal={(flag, manual) => this.setState({showExcelModal: flag, manual: manual})}
                        modal={this.state.showExcelModal}/>
                }

                {this.state.customaryPriceModal &&
                    <CustomaryPriceModal modal={this.state.customaryPriceModal}
                                         toggle={(flag, manual) => this.setState({
                                             customaryPriceModal: flag,
                                             manual: manual
                                         })}
                                         paymentInfo={this.state.paymentInfo}
                                         paytrDomain={this.props.currentUser.paytrDomain}/>
                }

                {this.state.connectorPaymentModal &&
                    <ConnectorPaymentModal modal={this.state.connectorPaymentModal}
                                           toggle={(flag, manual) => this.setState({
                                               connectorPaymentModal: flag,
                                               manual: manual
                                           })}
                                           paymentInfo={this.state.paymentInfo}
                                           currentUser={this.props.currentUser}/>
                }

                {this.state.showConnectorModal &&
                    <ConnectorModal
                        modal={this.state.showConnectorModal}
                        modalType={'get'}
                        type="sigorta"
                        currentUser={this.props.currentUser}
                        toggleModal={(showConnectorModal) => this.setState({showConnectorModal, manual:true})}
                    />
                }
            </div>
        )
    }
}

export default SigortaTmpList;